
const apiConfig = {
    baseUrl: process.env.REACT_APP_BASE_URL + '/api/', // https://bik.ru/api/
    baseUrlMedia: process.env.REACT_APP_BASE_URL_MEDIA
}

export default apiConfig;